<template lang="pug">
	.ai-music--new-ai-music-form
		Popup(v-if="newItemPopupVisible || isBatch", :popupVisible.sync="newItemPopupVisible", :title="isBatch ? $tCaption('Batch creation') : $tCaption('New AI Song')", :width="720", :autosize="true", :closeOnOutsideClick="false", :showMaximize="true")
			.root
				.flex-col.space-medium(:class="{ 'disabled-controls': isLoading }")
					template(v-if="isBatch")
						.flex-row.space.align-center
							DxButton(:text="$tCaption('Select song')", @click="$refs.songLyricsHelper.show()")
							Loader(v-if="isLoading", text="")
						.flex-col.space-small
							.font-small.upper.grey {{$tCaption('Artist')}}
							DxTextBox(:value.sync="originalSong.Artist", stylingMode="filled")
								dx-validator
									dx-required-rule(:message="$tCaption('Artist is required')")
						.flex-col.space-small.flex-2
							.flex-row.space.align-center
								.font-small.upper.grey {{$tCaption('Category')}}
								Loader(v-if="isLoadingPrompt", text="")
							Dropdown(ref="category", 
								:getTotal="(r) => r.TotalNumberOfRecords", :getItems="(r) => r.Results", :getData="loadCategories",
								:columns="[{ dataField: 'Name', caption: $tCaption('Category') }]",
								displayExpr="Name",
								valueExpr="Oid",
								:selectedItems="newMusicAiItem.Category && newMusicAiItem.Category.Oid",
								:showColumnHeaders="false",
								:filtersVisible="false",
								:searchVisible="true",
								:multiple="false",
								stylingMode="filled"
								@select-data="onCategorySelect")
						.flex-col.space-small
							.font-small.upper.grey {{$tCaption('Style')}}
							.flex-row.space.align-center
								DxTextArea.flex-1(:value.sync="originalSong.Style", stylingMode="filled", :height="80")
									dx-validator
										dx-required-rule(:message="$tCaption('Style is required')")
								StylesLibrary(@select="v => originalSong.Style = v", :currentStyle="originalSong.Style")
					template(v-else)
						.flex-col.space-small
							.font-small.upper.grey {{$tCaption('Title')}}
							DxTextBox(:value.sync="newMusicAiItem.Name", stylingMode="filled")
								dx-validator
									dx-required-rule(:message="$tCaption('Title is required')")
						.flex-col.space-small
							.font-small.upper.grey {{$tCaption('Artist')}}
							DxTextBox(:value.sync="newMusicAiItem.Artist", stylingMode="filled")
								dx-validator
									dx-required-rule(:message="$tCaption('Artist is required')")
						.flex-col.space-small.flex-2
							.flex-row.space.align-center
								.font-small.upper.grey {{$tCaption('Category')}}
								Loader(v-if="isLoadingPrompt", text="")
							Dropdown(ref="category", 
								:getTotal="(r) => r.TotalNumberOfRecords", :getItems="(r) => r.Results", :getData="loadCategories",
								:columns="[{ dataField: 'Name', caption: $tCaption('Category') }]",
								displayExpr="Name",
								valueExpr="Oid",
								:selectedItems="newMusicAiItem.Category && newMusicAiItem.Category.Oid",
								:showColumnHeaders="false",
								:filtersVisible="false",
								:searchVisible="true",
								:multiple="false",
								stylingMode="filled"
								@select-data="onCategorySelect")
						.flex-col.space-small
							.font-small.upper.grey {{$tCaption('Style')}}
							.flex-row.space.align-center
								DxTextArea.flex-1(:value.sync="newMusicAiItem.Style", stylingMode="filled", :height="80")
									dx-validator
										dx-required-rule(:message="$tCaption('Style is required')")
								StylesLibrary(@select="v => newMusicAiItem.Style = v", :currentStyle="newMusicAiItem.Style")
						.flex-col.space-small
							.flex-row.space.justify
								.flex-row.space-medium.align-center
									.font-small.upper.grey {{instrumental ? $tCaption('Song description') : $tCaption('Lyrics')}}
									DxCheckBox(:value.sync="instrumental", :text="$tCaption('Instrumental')")
								a.clickable.hoverable(@click="$refs.songLyricsHelper.show()") {{instrumental ? $tCaption('Choose song') : $tCaption('Generate lyrics')}}
							DxTextArea(:value.sync="newMusicAiItem.Lyric", :height="400", stylingMode="filled")
								dx-validator
									dx-required-rule(v-if="!instrumental", :message="$tCaption('Lyrics is required')")
					.flex-row.space-medium
						.flex-col.space-small.flex-1
							.font-small.upper.grey {{$tCaption('Song count')}}
							DxNumberBox(:value.sync="newMusicAiItem.SongCount", stylingMode="filled", :showSpinButtons="true", :min="0", :step="2")
						.flex-col.space-small.flex-1(v-if="isBatch")
							.font-small.upper.grey {{$tCaption('Lyrics count')}}
							DxNumberBox(:value.sync="newMusicAiItem.LyricCount", stylingMode="filled", :showSpinButtons="true", :min="0")
						.flex-col.space-small.flex-2(v-if="!isBatch && !instrumental")
							.flex-row.space.align-center
								.font-small.upper.grey {{$tCaption('AI Prompt')}}
								Loader(v-if="isLoadingPrompt", text="")
							Dropdown(ref="prompt", 
								:getTotal="(r) => r.TotalNumberOfRecords", :getItems="(r) => r.Results", :getData="loadPrompts",
								:columns="[{ dataField: 'Name', caption: $tCaption('Prompt') }]",
								displayExpr="Name",
								valueExpr="Oid",
								:selectedItems="newMusicAiItem.PromptId",
								:showColumnHeaders="false",
								:filtersVisible="false",
								:searchVisible="true",
								:multiple="false",
								stylingMode="filled"
								@select-data="selectPrompt")
					.flex-col.space(v-for="param in promptParameters")
						.font-small.upper.grey {{param.Description || param.Name}}
						DxTextBox(:value.sync="param.DefaultValue", stylingMode="filled")
							dx-validator
								dx-required-rule(:message="$tCaption('PARAM is required').replace(/PARAM/g, param.Description || param.Name)")
					.flex-col.space(v-if="isBatch && (originalSong.Lyric || originalSong.Name || originalSong.Artist)")
						.flex-row.space.font-big.upper.grey
							span {{$tCaption('Selected song: ')}}
							span {{originalSong.Name}} - {{originalSong.Artist}}
						.flex-col.space-small(v-if="originalSong.Lyric")
							pre.pre-wrap.font-small {{originalSong.Lyric}}
				Loader(v-if="isLoading", :text="generatorStatus", :fullscreen="true")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Cancel', '@actions')", @click="newItemPopupVisible = false", :disabled="!!isLoading")
				DxButton(:text="$tCaption('Save', '@actions')", @click="newMusicAIGenerate", :disabled="!canSave", type="success")
		SongLyricsHelper(ref="songLyricsHelper", @process="onSongLyricsHelperProcess", :isBatch="isBatch", :instrumental="instrumental", :title="instrumental ? $tCaption('Choose song') : ''")
</template>

<script>
	import _ from 'lodash';
	import DxButton from 'devextreme-vue/button';
	import DxTextBox from 'devextreme-vue/text-box';
	import DxTextArea from 'devextreme-vue/text-area';
	import DxNumberBox from 'devextreme-vue/number-box';
	import DxSelectBox from 'devextreme-vue/select-box';
	import DxCheckBox from 'devextreme-vue/check-box';
	import Loader from 'app-core/Loader.vue';
	import Dropdown from 'app-core/Dropdown.vue';
	import DxValidator, { DxRequiredRule, DxCustomRule } from 'devextreme-vue/validator';
	import { getValuesFromPropmtResponse } from './ai-music-helper';
	import Popup from 'app-core/Popup.vue';
	import SongLyricsHelper from './SongLyricsHelper.vue';
	import StylesLibrary from './StylesLibrary.vue';

	export default {
		translationCategory: 'aiMusic.Detail',
		name: 'ai-music-detail',
		components: {
			DxButton, DxTextBox, DxTextArea, Loader, DxNumberBox, DxSelectBox, Dropdown, DxValidator, DxRequiredRule, DxCustomRule, Popup,
			SongLyricsHelper, DxCheckBox, StylesLibrary
		},
		props: ['item', 'isDebug'],
		data() {
			return {
				newItemPopupVisible: false,
				promptParameters: [],
				isLoadingPrompt: false,
				isLoading: 0,
				newMusicAiItem: {
					Name: null,
					Style: null,
					Lyric: null,
					Artist: null,
					Keywords: null,
					PromptId: null,
					LyricCount: 1,
					SongCount: 2,
					Category: null
				},
				generatorStatus: null,
				isBatch: false,
				generatorResult: null,
				originalSong: { 
					Lyric: null,
					Name: null,
					Artist: null,
					Style: null,
					Language: null
				},
				instrumental: false
			};
		},
		computed: {
			hasOriginalSong() {
				return this.originalSong.Lyric || this.originalSong.Name || this.originalSong.Artist;
			},
			canSave() {
				let canSave = !(this.isLoadingPrompt || this.isLoading);
				return canSave && (!this.isBatch || this.hasOriginalSong);
			}
		},
		watch: {
			
		},
		mounted() {
			if (__DEBUG__)
				window.aiMusicNew = this;

			this.$eventsBus.$on('signalr-on-notification', this.signalrOnNotification);
		},
		destroyed() {
			this.$eventsBus.$off('signalr-on-notification', this.signalrOnNotification);
		},
		methods: {
			onCategorySelect(v) {
				this.newMusicAiItem.Category = v;

				if (this.newMusicAiItem?.Style) {
					if (this.newMusicAiItem?.Style.indexOf(v?.Name) === -1) {
						this.newMusicAiItem.Style += `, ${v?.Name}`;
					}
				} else {
					this.newMusicAiItem.Style = v?.Name;
				}
			},
			loadCategories(pageIndex, limit, opts) {
				let filter = [];
				if (opts?.byKey) {
					filter = ['Oid', '=', opts.byKey];
				}
				let filterCriteria = `${filter && filter.length && `&filterCriteria=${encodeURIComponent(JSON.stringify(filter))}` || ''}`;
				let sorting = `&sorting=[{ selector: 'Name' }]`;
				return this.$Data.getExternalApi('AzureMediaCategory/List', `page=${pageIndex + 1}${filterCriteria}${sorting}`, limit);
			},
			async onSongLyricsHelperProcess(opts) {
				this.newMusicAiItem.Name = opts?.title || this.newMusicAiItem.Name;
				this.newMusicAiItem.Artist = opts?.artist || this.newMusicAiItem.Artist;
				this.newMusicAiItem.Lyric = opts?.lyrics || this.newMusicAiItem.Lyrics;
				this.newMusicAiItem.Style = opts?.style || opts.keywords || this.newMusicAiItem.Style;
				this.generatorResult = this.$refs.songLyricsHelper.result;
				this.originalSong.Name = this.generatorResult?.Title;
				this.originalSong.Artist = this.generatorResult?.Artist;
				this.originalSong.Lyric = this.generatorResult?.Text;
				this.originalSong.Album = this.generatorResult?.Album;
				this.originalSong.Language = this.generatorResult?.Language;

				if (this.isBatch) {
					this.newItemPopupVisible = true;

					this.isLoading++;
					const results = JSON.parse((await this.$Data.postExternalApi('OpenAiGpt3/Run', {
						PromptCode: 'AIMUSIC_GENERATE_STYLE',
						clientIp: this.$auth.userIP(),
						parameters: {
							Song_Artist: this.originalSong.Artist,
							Song_Title: this.originalSong.Name,
							Song_Text: this.originalSong.Lyric
						}
					}).finally(() => this.isLoading--))?.Data?.Content);

					_.assign(this.originalSong, results);

					if (__DEBUG__)
						console.debug('Result AIMUSIC_GENERATE_STYLE', { results });
				} else if (this.instrumental) {
					this.isLoading++;
					const results = JSON.parse((await this.$Data.postExternalApi('OpenAiGpt3/Run', {
						PromptCode: 'AIMUSIC_GENERATE_DESCRIPTION',
						clientIp: this.$auth.userIP(),
						parameters: {
							Song_Artist: this.originalSong.Artist,
							Song_Title: this.originalSong.Name,
							Song_Text: this.originalSong.Lyric
						}
					}).finally(() => this.isLoading--))?.Data?.Content);

					this.newMusicAiItem.Lyric = results?.Description || this.newMusicAiItem.Lyric;
					this.newMusicAiItem.Style = results?.Style || this.newMusicAiItem.Style;
					this.newMusicAiItem.Name = results?.Title || this.newMusicAiItem.Name;
					this.newMusicAiItem.Artist = results?.Artist || this.newMusicAiItem.Artist;

					if (__DEBUG__)
						console.debug('Result AIMUSIC_GENERATE_DESCRIPTION', { results });
				}
			},
			signalrOnNotification({ eventName, data }) {
				if (eventName === 'AIScriptGenerator.Started') {
					this.generatorStatus = data.Name;
				}
			},
			async selectPrompt(v) {
				this.newMusicAiItem.PromptId = v && v.Oid || null;
				this.promptParameters = [];
				if (v) {
					this.isLoadingPrompt++;
					this.promptParameters = (await this.$Data.getExternalApi('AIScriptParameter/List', `aiScriptGeneratorId=${v.Oid}&page=1`, 999).finally(() => this.isLoadingPrompt--))?.Results
						.filter(f => !['Song_Title', 'Song_Artist', 'Song_Text'].includes(f.Name));
				}
			},
			async newMusicAIGenerate(e) {
				if (this.isBatch) {
					this.isLoading++;
					await this.$Data.postExternalApi('AiMusic/GenerateBatch', {
						...this.originalSong,
						Debug: this.isDebug,
						LyricCount: this.newMusicAiItem.LyricCount,
						RunLyricGeneration: true,
						SongCount: this.newMusicAiItem.SongCount / 2,
						Immediate: this.newMusicAiItem.SongCount > 0,
						CategoryId: this.newMusicAiItem.Category?.Oid
					}).finally(() => this.isLoading--);

					this.newItemPopupVisible = false;
					this.$emit('reload');
				} else {
					if (e?.validationGroup && !e.validationGroup.validate().isValid) {
						return;
					}

					this.generatorStatus = null;
					if (this.newMusicAiItem.PromptId) {
						await this.applySelectedPrompt();
					}

					this.isLoading++;
					try {
						if (this.newMusicAiItem.LyricCount > 1) {
							let lyricCount = Math.max(0, this.newMusicAiItem.LyricCount - 1 || 0);

							await this.$Data.postExternalApi('AiMusic/GenerateBatch', {
								...this.newMusicAiItem,
								Debug: this.isDebug,
								LyricCount: lyricCount,
								RunLyricGeneration: true,
								SongCount: this.newMusicAiItem.SongCount / 2,
								Immediate: this.newMusicAiItem.SongCount > 0,
								CategoryId: this.newMusicAiItem.Category?.Oid
							});
						}

						await this.$Data.postExternalApi('AiMusic/Generate', {
							...this.newMusicAiItem,
							Debug: this.isDebug,
							SongCount: this.newMusicAiItem.SongCount / 2,
							Instrumental: this.instrumental,
							CategoryId: this.newMusicAiItem.Category?.Oid
						});
					} finally {
						this.newItemPopupVisible = false;
						this.isLoading--;
						this.$emit('reload');
					}
				}
			},
			async applySelectedPrompt() {
				this.isLoading++;
				let parameters = {
					Song_Artist: this.newMusicAiItem.Artist,
					Song_Text: this.newMusicAiItem.Lyric,
					Song_Title: this.newMusicAiItem.Name
				}

				this.promptParameters.map(f => {
					parameters[f.Name] = f.DefaultValue;
				});

				const results = (await this.$Data.postExternalApi('OpenAiGpt3/Run', {
					PromptId: this.newMusicAiItem.PromptId,
					clientIp: this.$auth.userIP(),
					parameters
				}).finally(() => this.isLoading--))?.Data?.Content;

				let parsedValues = getValuesFromPropmtResponse(results) || {};

				this.newMusicAiItem.Name = parsedValues.title || this.newMusicAiItem.Name;
				this.newMusicAiItem.Artist = parsedValues.artist || this.newMusicAiItem.Artist;
				this.newMusicAiItem.Lyric = parsedValues.lyrics || this.newMusicAiItem.Lyrics;
				this.newMusicAiItem.Style = parsedValues.style || this.newMusicAiItem.Style;
			},
			loadPrompts(pageIndex, limit, opts) {
				let filter = ['UseType', '=', 4];
				if (opts?.byKey) {
					filter = ['Oid', '=', opts.byKey];
				}
				let filterCriteria = `${filter && filter.length && `&filterCriteria=${encodeURIComponent(JSON.stringify(filter))}` || ''}`;
				return this.$Data.getExternalApi('AIScriptGenerator/List', `page=${pageIndex + 1}${filterCriteria}`, limit);
			},
			newMusicAI(opts) {
				this.newMusicAiItem = {
					Name: null,
					Style: null,
					Lyric: null,
					Keywords: null,
					Artist: null,
					SongCount: 2,
					LyricCount: 1,
					Category: null
				};
				this.generatorResult = null;
				this.promptParameters = [];
				this.newItemPopupVisible = false;
				this.isBatch = !!opts?.batch;
				this.originalSong = { 
					Lyric: null,
					Name: null,
					Artist: null,
					Style: null,
					Language: null
				}
				this.$nextTick(() => {
					if (this.isBatch) {
						this.$nextTick(() => {
							this.$refs.songLyricsHelper.show()
						});
					} else {
						this.newItemPopupVisible = true;
					}
				});
			},
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";

	.ai-music--new-ai-music-form {
		
	}
</style>
 